import { render, staticRenderFns } from "./guidanceList.vue?vue&type=template&id=f54c8686&scoped=true&"
import script from "./guidanceList.vue?vue&type=script&lang=js&"
export * from "./guidanceList.vue?vue&type=script&lang=js&"
import style0 from "./guidanceList.vue?vue&type=style&index=0&id=f54c8686&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f54c8686",
  null
  
)

export default component.exports